/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-history.reducer';

export const PharmacyHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyHistoryEntity = useAppSelector(state => state.pharmacyHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyHistory.detail.title">PharmacyHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyHistoryEntity.id}</dd>
          <dt>
            <span id="tmDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyHistory.tmDate">Tm Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyHistoryEntity.tmDate}</dd>
          <dt>
            <span id="noOfDrugs">
              <Translate contentKey="tinyMedicRestApp.pharmacyHistory.noOfDrugs">No Of Drugs</Translate>
            </span>
          </dt>
          <dd>{pharmacyHistoryEntity.noOfDrugs}</dd>
          <dt>
            <span id="excluded">
              <Translate contentKey="tinyMedicRestApp.pharmacyHistory.excluded">Excluded</Translate>
            </span>
          </dt>
          <dd>{pharmacyHistoryEntity.excluded}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyHistory.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyHistoryEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyHistoryEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyHistory.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyHistoryEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyHistoryEntity.cursor}</dd>
          <dt>
            <span id="billNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyHistory.billNumber">Bill Number</Translate>
            </span>
          </dt>
          <dd>{pharmacyHistoryEntity.billNumber}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyHistory.bill">Bill</Translate>
          </dt>
          <dd>{pharmacyHistoryEntity.bill ? pharmacyHistoryEntity.bill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyHistory.prescription">Prescription</Translate>
          </dt>
          <dd>{pharmacyHistoryEntity.prescription ? pharmacyHistoryEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyHistory.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyHistoryEntity.pharmacy ? pharmacyHistoryEntity.pharmacy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-history/${pharmacyHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyHistoryDetail;
